import {logEvent} from '../logEvent';

export function logClickedReferAFriendButton() {
  logEvent('clicked refer a friend button', {});
}
